import { render, staticRenderFns } from "./_channel-dependencies.vue?vue&type=template&id=37b434f0"
import script from "./_channel-dependencies.vue?vue&type=script&lang=js"
export * from "./_channel-dependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports